import {inject} from "aurelia-framework";
import {OperationInterface} from "./operation.interface";
import {DialogService} from "aurelia-dialog";
import {BulkOperationQueryCore} from "./utility/bulk-operation-query-core";
import {SelectMediaBundleView} from "./utility/select-media-bundle-view";
import {I18N} from "aurelia-i18n";
import {Client} from "../../api/client";
import {FlashService} from "../../flash/flash-service";

@inject(
    DialogService,
    BulkOperationQueryCore,
    I18N,
    Client,
    FlashService
)
export class RemoveFromMediaBundle extends OperationInterface
{
    constructor(dialogService, bulkOperationQueryCore, i18n, client, flash) {
        super();
        this.dialogService = dialogService;
        this.bulkOperationQueryCore = bulkOperationQueryCore;
        this.i18n = i18n;
        this.client = client;
        this.flash = flash;
    }

    /*public*/ getName()
{
    return 'remove-from-media-bundle';
}

    /*public*/ execute(context)
{
    if (context.contextObjectRef?.modelId === 'media-database/media-bundle') {
        return this.bulkOperationQueryCore.query(
            context.operationConfig.type,
            {
                items: context.items,
                mediaBundles: [context.contextObjectRef],
            }
        );
    }

    const items = context.items.map(item => ({
        id: item.id,
        modelId: item.modelId
    }));

    return this.client.post('media-database/media-items/bundles', { items })
        .then(response => {
            const bundles = Array.from(response.data ?? response);

            if (bundles.length === 0) {
                this.flash.error('media-database.bulk-operation.no-bundles');
                return;
            }

            return this.dialogService.open({
                viewModel: SelectMediaBundleView,
                model: {
                    title: 'media-database.bulk-operation.remove-from-media-bundle',
                    multiple: true,
                    bundles: bundles,
                    onSave: this.onSaveCallback(context).bind(this)
                }
            }).whenClosed();
        });
}

    /*public*/ getActions(items, operationConfig)
{
    return [
        {
            type: 'bulk-operation',
            operationConfig: operationConfig,
            label: this.i18n.tr('media-database.bulk-operation.remove-from-media-bundle'),
        }
    ];
}

    /*private*/ onSaveCallback(context)
{
    return (result) => {
        const bundle = result?.bundle ?? result;
        const bundles = Array.isArray(bundle) ? bundle : [bundle];

        return this.bulkOperationQueryCore.query(
            context.operationConfig.type,
            {
                items: context.items,
                mediaBundles: bundles,
            }
        );
    };
}
}
